import * as R from 'ramda'
import { InitiativeFieldId } from '@/constants/initiative/filter'

const formatFields = field => ({
  id: `cf_${field.id}`,
  label: field.name,
  type: field.type,
  fieldType: 'custom_field',
  projectId: field.projectId
})
export default (filterConfiguration, orgCFs, includeProjectField) => {
  if (!filterConfiguration) return null
  let [orgLevelCustomFields, projectCFs] = R.partition(field => !field.projectId, orgCFs)
  orgLevelCustomFields = orgLevelCustomFields.map(formatFields)
  projectCFs = projectCFs.map(formatFields)
  projectCFs = R.sort(R.ascend(R.prop('projectId')), projectCFs) // group CFs by project
  const filtersList = [
    { id: InitiativeFieldId.PRIMARY_OWNER, label: 'Owner', fieldType: 'system_field' },
    { id: InitiativeFieldId.OWNER, label: 'Owner or co-owner', fieldType: 'system_field' },
    { id: InitiativeFieldId.CREATED_AT, label: 'Creation date', fieldType: 'system_field' },
    { id: InitiativeFieldId.UPDATED_AT, label: 'Last updated', fieldType: 'system_field' },
    { id: InitiativeFieldId.DUE_DATE, label: 'Due date', fieldType: 'system_field' },
    { id: InitiativeFieldId.CLOSED_ON, label: 'Closed On', fieldType: 'system_field' },
    { id: InitiativeFieldId.STATUS, label: 'Status', fieldType: 'system_field' },
    {
      id: InitiativeFieldId.PRIORITY,
      label: 'Priority',
      fieldType: 'system_field'
    },
    { id: InitiativeFieldId.KEY_RESULT, label: 'Key result (KR)', fieldType: 'system_field' },
    ...(includeProjectField
      ? [{ id: InitiativeFieldId.PROJECT, label: 'Project', fieldType: 'system_field' }]
      : []),
    { id: InitiativeFieldId.COMMENT_COUNT, label: 'Comment count', fieldType: 'system_field' },
    { id: InitiativeFieldId.LAST_COMMENT_ON, label: 'Last comment on', fieldType: 'system_field' },
    { id: InitiativeFieldId.LAST_UPDATED_BY, label: 'Last updated by', fieldType: 'system_field' },
    {
      id: InitiativeFieldId.LAST_COMMENT_UPDATE_ON,
      label: 'Last comment update on',
      fieldType: 'system_field'
    },
    { id: InitiativeFieldId.LAST_MENTION_ON, label: 'Last mention on', fieldType: 'system_field' }
  ].map(field => ({
    ...field,
    type: filterConfiguration.fields[field.id]
  }))
  return [...filtersList, ...orgLevelCustomFields, ...projectCFs]
}
